import(/* webpackMode: "eager" */ "/builds/seayatech1/aztangofest-fe/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/seayatech1/aztangofest-fe/src/styles/globals.css");
